import React from "react";

import { motion } from "framer-motion";
import settings from "configs/settings";

const AnimatedRoute = ( props ) => {

    const pageTransition = {
        in: {
            opacity: 1,
            transition: {
                duration: settings.router.animationDurationOnRouteChange/*  * 3 */,
            },
           // y: 0,
        },
        out: {
            opacity:0,
            transition: {
                duration: settings.router.animationDurationOnRouteChange,
            },
            //y: "-100%",
        }
    }

    return (
        <motion.div className={"content " + props.className} initial="out" animate="in" exit="out" variants={pageTransition}>
            {props.children}
        </motion.div>
    )
}

export default AnimatedRoute;